<div class="portal--header">
  <h1 class="heading">Roadmap</h1>
</div>
<div class="portal--main">
  <div class="flex-grid space-between bottom stack-sm">
    <div class="flex-grid--item">
      <button id="toggle-button" class="focus-element open" collapsible [collapsibleSection]="collapsibleSection" [collapsibleTitle]="collapsibleTitle"><span class="focus--content" tabindex="-1"><span class='accordion-toggle open' #collapsibleTitle style="margin-top: 0;">Filter by <svg class="ic-arrow"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg></span></span></button>
      <div class="collapsible" #collapsibleSection>
        <div class="btn-group">
          <button class="std-btn filter focus-element" [ngClass]="{'active': filterList[i].isClicked}" (mouseup)="filterUpdated(i)" *ngFor="let filter of filterList; let i = index"><span class="focus--content" tabindex="-1">{{filter.label}} <span class="detail">{{filter.amount}}</span></span></button>
        </div>
      </div>
    </div>
  </div>

  <div class="text-img-block-wrapper" *ngFor="let roadmap of filteredRoadMaps">

    <div class="lg-text-wrapper" *ngIf="filteredRoadMaps.length > 0">
      <span class="lg">{{roadmap.status}}</span>
      <span class="xl">{{roadmap.monthAndYear}}<span class="break">{{roadmap.year}}</span></span>
    </div>
    <div class="module drop-shadow bottom text-img-block" *ngIf="filteredRoadMaps.length > 0">
      <div class="text-img-block--img bg-img__cover" [ngStyle]="{'background-image': 'url(' + roadmap.imageUrl + ')'}"></div>
      <div class="text">
        <h2 class="text-img-block--heading">{{roadmap.title}} <span class="subheading">20/09/2018</span></h2>
        <p>{{roadmap.description}}</p>
      </div>
    </div>
  </div>
  <div *ngIf="filteredRoadMaps.length == 0">
    <p style="text-align:center">No roadmap data avaliable</p>
  </div>
</div>
